var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"neumorphism-out mr-5",attrs:{"icon":"","title":_vm.$t('nav.tooltipMode')},on:{"click":function($event){_vm.dark = !_vm.dark}}},[_c('v-icon',[_vm._v("mdi-"+_vm._s(_vm.dark ? "white-balance-sunny" : "moon-waning-crescent"))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }